export default {
  getDailyInspection: (state) => state.dailyInspection,
};
